module.exports = __webpack_public_path__ + "static/media/superBlot-0.91d817f4.png";